export default __webpack_public_path__ + "static/media/gvsu.1d45e7a1.png";